module.exports = __webpack_public_path__ + "img/person-24px.dc78a34d.svg";